import React from 'react';
import BaseCompetency from '../Application/BaseCompetency';
import { HHA_COMPETENCY_ITEMS } from './hhaConstants';

const HhaCompetency = ({ targetUserId, onClose }) => {
    return (
        <BaseCompetency
            role="HHA"
            title="HHA CLINICAL COMPETENCY ASSESSMENT"
            items={HHA_COMPETENCY_ITEMS}
            totalPages={3}
            apiEndpoint="/competencies"
            fetchEndpoint="/competencies"
            defaultValues={{
                userId: targetUserId || 1
            }}
            onClose={onClose}
        />
    );
};

export default HhaCompetency;
